<template>
<div class="search">
    <div class="navigator">
        <div @click="$router.back()">
            <i class="el-icon-arrow-left"></i>
            <span>搜索</span>
        </div>
    </div>
    <div class="search-box">
        <div>
            <i class="el-icon-search"></i>
            <input type="text" v-model="str" placeholder="搜索想要的产品" @keyup.enter="search" />
        </div>
    </div>
    <ul>
        <router-link tag="li" v-for="(item,index) in options" :key="index" :to="{path:'/product/detail',query:{
            idx:item.classe_id,
            id:item.id
        }}">{{item.name}}</router-link>
    </ul>
</div>
</template>

<script>
import {
    productList
} from "../assets/js/api";
export default {
    data() {
        return {
            str: "",
            options: [],
        };
    },
    methods: {
        search() {
            productList({
                    limit: 9999,
                    page: 1,
                    where: {
                        name: this.str,
                    },
                })
                .then((r) => {
                    this.options = r.data.data;
                })
                .catch((err) => {});
        },
    },
};
</script>

<style lang="less" scoped>
.search {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 3;
    background: rgb(246, 246, 246);

    .navigator div:active {
        opacity: 0.78;
    }

    .navigator {
        height: 0.88rem;
        line-height: .88rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        background: white;
        padding: 0 0.3rem;
        box-sizing: border-box;

        div {
            width: 2rem;
            display: flex;
            align-items: center;
        }

        i {
            margin-right: 0.1rem;
            font-size: 0.5rem;
        }

        span {
            font-size: 0.36rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
        }
    }

    .search-box {
        padding: 0.37rem 0.3rem;
        box-sizing: border-box;
        background: white;
        width: 100%;

        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        div {
            height: 0.78rem;
            background: #f2f2f2;
            width: 100%;
            border-radius: 0.39rem;
            display: flex;
            align-items: center;
            width: 100%;
            padding: 0 0.3rem;
            box-sizing: border-box;

            i {
                color: rgba(0, 0, 0, 0.4);
                font-size: 0.5rem;
            }

            input {
                outline: none;
                border: none;
                margin-left: 0.2rem;
                background: transparent;
                font-size: 0.24rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
            }
        }
    }
}

li {
    padding: 0.3rem;
    box-sizing: border-box;
    border-bottom: 1px solid lightgray;
    font-size: 0.28rem;
    color: black;
    background: white;
}
</style>
